$(function () {
  // トップページのスライダーの設定
  $('.js-slider').slick({
    accessibility: true,
    dots: false,
    arrows: false,
    fade: true,
    speed: 2000,
    autoplaySpeed: 4000,
    pauseOnHover: false
  });
  // 最初のアニメーション
  var $opening = $('.opening');
  var $opAnimationElm = $('.opAnimation');
  var $cover = $('.mainImage_cover');
  // .openingのアニメーションが始まったとき
  $opening.on('animationstart webkitAnimationStart', function (e) {
    if (e.target.className === 'opening') {
      // カバーの.opAnimationをとる
      $cover.removeClass('opAnimation');
      // スライダーノインデックスを1に移動
      $('.js-slider').slick('slickGoTo', 1, true);
      setTimeout(function () {
        // スライダーのオートプレイを開始
        $('.js-slider').slick('slickPlay');
      }, 2000);
    }
  });
  // .openingのアニメーションが終わったとき
  $opening.on('animationend webkitAnimationEnd', function (e) {
    if (e.target.className === 'opening') {
      $(this).hide();
      $opAnimationElm.each(function () {
        $(this).removeClass('opAnimation');
      });
    }
  });
  // メインイメージ部分の高さ調整
  mainImageHeight();
});

// ウインドウをリサイズした時、メインイメージ部分の高さ調整
$(window).on('resize', mainImageHeight);

// メインイメージ部分の高さ調整する関数
function mainImageHeight () {
  const headerHeight = $('.header').height();
  const windowHeight = $(window).height();
  const windowWidth = $(window).width();
  let imageHeight;
  if (windowWidth < 1024) {
    imageHeight = windowHeight - headerHeight;
  } else {
    imageHeight = windowHeight;
  }
  $('.mainImage').height(imageHeight);
  $('.mainImage_slide_photo').height(imageHeight);
}
